import { UseMutationOptions } from '@tanstack/react-query';

import useMutation from 'hooks/useMutation';
import { CuredApiPaths } from 'models/enums';

import MutationKeys from './keys';

import type { GenerateCopyRequest, GenerateCopyResponse } from 'domains/content/components/CopyGeneratorChat/utils';

export type { GenerateCopyRequest, GenerateCopyResponse };

/**
 * Requests the next assistant turn for Ask Sara.
 * On first call, omit sessionId — the backend creates a new session and returns its ID.
 * On subsequent calls, pass the sessionId received from the previous response.
 * @see CuredApiPaths.COPY_GENERATOR_GENERATE
 */
const useGenerateCopy = (mutateOptions?: UseMutationOptions<GenerateCopyResponse, Error, GenerateCopyRequest>) =>
    useMutation<GenerateCopyRequest, GenerateCopyResponse, Error>(
        MutationKeys.COPY_GENERATOR_GENERATE,
        CuredApiPaths.COPY_GENERATOR_GENERATE,
        mutateOptions
    );

export default useGenerateCopy;
